import { Component, ChangeDetectorRef, ChangeDetectionStrategy } from '@angular/core';
import { FormControl, FormBuilder } from '@angular/forms';
import { SeConstraintNotifierService, ICheckedEntity } from '@se/se.platform.base';
import { Logger } from '@se/se.platform.base';
import { combineLatest } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { findIndex } from 'lodash-es';
import { IControlType } from '@se/cp.common';
import { CpRadioControl, IRadioButton } from '../../cp-configuration/view-model';
import { CpModelService } from '../../cp-model.service';
import { AbstractControlComponent } from '../abstract-control';

@Component({
    selector: 'cp-radio',
    templateUrl: './radio.component.html',
    styleUrls: ['./radio.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class CpRadioComponent extends AbstractControlComponent {
    control!: CpRadioControl;
    entities: ICheckedEntity[] = [];
    controlType = IControlType;
    constructor(
        private fb: FormBuilder,
        private modelService: CpModelService,
        cdr: ChangeDetectorRef,
        constraintNotifier: SeConstraintNotifierService,
        logger: Logger
    ) {
        super(cdr, constraintNotifier, logger);
    }

    getButtonId(button: IRadioButton) {
        return button.dataBinding?.toString();
    }

    onFocus() {
        this.focusin.emit();
    }

    onModelChange(model: Record<string, number>) {
        return this.control.onModelChange(this.modelService, model[this.control.id], !this.isDisabled);
    }

    protected init() {
        const buttons = this.control.buttons || [];

        const initialValues = buttons.map(
            (button) => [this.modelService.registerEntity(button.dataBinding.entity), button.dataBinding] as const
        );

        // Creiamo un adattatore tra il valore dei radio (un numero) e il valore in output del controllo (un array di booleani).
        this.formControl = this.fb.group({
            [this.control.id]: new FormControl(
                this.control.getInitialValue(this.modelService),
                initialValues.map(([entity, dataBinding]) =>
                    this.makeValidator(entity, dataBinding.propertyName, false)
                )
            ),
        });

        // Viene effettivamente fatto un dataBinding per ogni pulsante.
        combineLatest(initialValues.map(([_, dataBinding]) => this.modelService.register(dataBinding)))
            .pipe(takeUntil(this.destroyed$))
            .subscribe((model) => {
                let index = findIndex(model, (x) => !!x);
                if (index === -1) {
                    index = this.control.defaultIndex;
                }

                this.formControl?.setValue({
                    [this.control.id]: index,
                });

                this.cdr.detectChanges();
            });
    }

    protected updateFormControl() {
        super.updateFormControl();

        this.isDisabled ? this.formControl?.disable() : this.formControl?.enable();
    }
}
